import React from 'react';
import { Finding, Jurisdiction, Severity, Category } from '../../types/contractAnalyzer';

interface Filters {
  severity?: Severity | 'all';
  jurisdiction?: Jurisdiction | 'all';
  category?: Category | 'all';
  amendmentsOnly?: boolean;
}

interface FindingsFiltersProps {
  findings: Finding[];
  filters: Filters;
  onChange: (next: Filters) => void;
}

const unique = <T,>(arr: T[]) => Array.from(new Set(arr));

const FindingsFilters: React.FC<FindingsFiltersProps> = ({ findings, filters, onChange }) => {
  const severities = unique(findings.map(f => f.severity));
  const jurisdictions = unique(findings.map(f => f.jurisdiction));
  const categories = unique(findings.map(f => f.category));

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-wrap gap-4 items-end">
      <div>
        <label className="block text-xs text-gray-500 mb-1">Severity</label>
        <select
          className="rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          value={filters.severity || 'all'}
          onChange={(e) => onChange({ ...filters, severity: e.target.value as any })}
        >
          <option value="all">All</option>
          {severities.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Jurisdiction</label>
        <select
          className="rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          value={filters.jurisdiction || 'all'}
          onChange={(e) => onChange({ ...filters, jurisdiction: e.target.value as any })}
        >
          <option value="all">All</option>
          {jurisdictions.map(j => (
            <option key={j} value={j}>{j}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Category</label>
        <select
          className="rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          value={filters.category || 'all'}
          onChange={(e) => onChange({ ...filters, category: e.target.value as any })}
        >
          <option value="all">All</option>
          {categories.map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <input
          id="amendmentsOnly"
          type="checkbox"
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          checked={!!filters.amendmentsOnly}
          onChange={(e) => onChange({ ...filters, amendmentsOnly: e.target.checked })}
        />
        <label htmlFor="amendmentsOnly" className="text-sm text-gray-700">Amendments only</label>
      </div>
    </div>
  );
};

export type { Filters };
export default FindingsFilters;
